/**
 * Логотип в фирменном стиле «Этажей»: красный домик и надпись «этажи».
 * Рисунок свой (не копия файла с сайта компании), цвет — фирменный #F15044.
 */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="brand-logo" aria-label="Этажи">
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#F15044" d="M12 2.5 2 9.2V21.5h7v-6h6v6h7V9.2L12 2.5Zm0 3.1 6.5 4.4v1.6L12 7.2l-6.5 4.4V10L12 5.6Z" />
      </svg>
      <span className="brand-word">этажи</span>
    </span>
  )
}
